// cspell:disable
const vanityUrls = {
    'treasuryvanity.dev.jackhenry.com': 'tm554',
    'treasuryvanity.stg.jackhenry.com': 'tm554',
    'treasuryvanity.jackhenry.com': 'tm554',
    'business.abbank.com': 'abbank',
    'businessbanking.oakstarbank.com': 'oakstarbank',
    'cashmanagement.mybrb.bank': 'mybrb',
    'cm.reliancebank.bank': 'reliancebank',
    'cm.reliancebank.com': 'reliancebank',
    'commercial.alpinebank.com': 'alpinebank',
    'commercial.fidelitybankonline.com': 'fidelitybank',
    'commercial.summitcreditunion.com': 'summitcreditunion',
    'corporateo2.oldsecond.com': 'oldsecond',
    'elite.iconbusinessbank.com': 'iconbusinessbank',
    'emerald.stonebank.com': 'stonebank',
    'mytreasury.bankplus.net': 'bankplus',
    'mytreasury.citizensebank.com': 'citizensebank',
    'safraonecorporate.safra.com': 'safra',
    'syncbusiness.bibank.com': 'bibank',
    'tm.ambanking.com': 'ambanking',
    'tm.bankonmainstreet.com': 'bankonmainstreet',
    'tm.busey.com': 'busey',
    'tm.chelseastate.bank': 'chelseastatebank',
    'tm.firstoklahomabank.com': 'firstoklahomabank',
    'tm.grovebankandtrust.com': 'grovebank',
    'tm.linkbank.com': 'linkbank',
    'tm.luminate.bank': 'luminatebank',
    'tm.northstarathome.com': 'northstarathome',
    'tm.peapackprivate.com': 'peapackprivate',
    'tm.snbt.com': 'snbt',
    'tm.wmcb.com': 'wmcb',
    'tmbs.fabt.bank': 'fabt',
    'tmonline.univest.net': 'souderton',
    'tps.altabank.com': 'insighttreasury',
    'connect.insighttreasury.com': 'insighttreasury',
    'secure1.capecodfive.com': 'capecodfive',
    'treas.web5.com': 'web5',
    'treasury.alpinebank.com': 'alpinebank',
    'treasury.altosbank.com': 'altosbank',
    'treasury.americanpride.bank': 'americanpridebk',
    'treasury.armstrong.bank': 'armstrongbank',
    'treasury.bangor.com': 'bangor',
    'treasury.bankbsf.com': 'bankbsf',
    'treasury.bankeasy.com': 'bankeasy',
    'treasury.bankfirstfs.com': 'bankfirstfs',
    'treasury.bankofmissouri.com': 'bankofmissouri',
    'treasury.bankofpontiac.com': 'bankofpontiac',
    'treasury.bayfirstfinancial.com': 'bayfirstbank',
    'treasury.border.bank': 'borderbank',
    'treasury.btcbank.bank': 'btcbank',
    'treasury.chainbridgebank.com': 'chainbridge',
    'treasury.choiceone.bank': 'choiceone',
    'treasury.choiceone.com': 'choiceone',
    'treasury.climatefirstbank.com': 'climatefirstbank',
    'treasury.commerceonebank.com': 'cob',
    'treasury.craft.bank': 'craftbank',
    'treasury.cwbk.com': 'cwbk',
    'treasury.farmersbankgroup.com': 'farmersbankgroup',
    'treasury.fcbanking.com': 'fcbanking',
    'treasury.fieldandmain.com': 'fieldandmain',
    'treasury.firstwestern.bank': 'fwbt',
    'treasury.fnbank.net': 'fnbank',
    'treasury.greatsouthernbank.com': 'greatsouthernbank',
    'treasury.hawthornbank.com': 'hawthornbank',
    'treasury.idahofirstbank.com': 'idahofirstbank',
    'treasury.intrustbank.com': 'intrustbank',
    'treasury.jbt.bank': 'jbt',
    'treasury.lbtx.com': 'lbtx',
    'treasury.m1.bank': 'm1bank',
    'treasury.mabank.com': 'mabank',
    'treasury.mabreybank.com': 'mabreybank',
    'treasury.mbtga.com': 'mbtga',
    'treasury.mcb.com': 'mcb',
    'treasury.mycenturybank.com': 'centurybank',
    'treasury.nabna.com': 'nabna',
    'treasury.nbofi.com': 'nbofi',
    'treasury.orrstown.com': 'orrstown',
    'treasury.outdoorbank.com': 'outdoorbank',
    'treasury.securitybankkc.com': 'securitybankkc',
    'treasury.securityfederalbank.com': 'securityfederalbank',
    'treasury.smb-t.com': 'smbt',
    'treasury.sonatabank.com': 'sonatabank',
    'treasury.southwest.bank': 'southwestbank',
    'treasury.statebank1910.bank': 'statebank',
    'treasury.tandem.bank': 'tandembank',
    'treasury.texasbank.com': 'texasbank',
    'treasury.trustarbank.com': 'trustarbank',
    'treasury.ubmich.com': 'unionbank',
    'treasury.wilsonbank.com': 'wilsonbank',
    'treasurymanagement.bankofcastile.com': 'bankofcastile',
    'treasurymanagement.evergreenbankgroup.com': 'evergreenbankgroup',
    'treasurymanagement.fieldpointprivate.com': 'fieldpointprivate',
    'treasurymanagement.mahopacbank.com': 'mahopacbank',
    'treasurymanagement.pegasusbankdallas.com': 'pegasus',
    'treasurymanagement.simmonsbank.com': 'simmonsbank',
    'treasurymanagement.tompkinsbank.com': 'tompkinsbank',
    'treasurymanagement.vistbank.com': 'vistbank',
    'treasurysuite.tworivers.bank': 'tworivers',
    'treasury.citizenslc.com': 'citizenslc',
    'treasury.oxfordbank.bank': 'oxford',
    'treasury.regent.bank': 'regentbank',
    'tts.ifbbank.com': 'ifbbank',
    'vaultpro.portraitbank.com': 'portraitbank',
};
const vanityUrlToIdMap = new Map(Object.entries(vanityUrls));

module.exports = { vanityUrlToIdMap };
